import { Box, createStyles, makeStyles } from '@material-ui/core';
import Client from '@spike/client-model';
import { ClientEditHeader } from 'components/Client/ClientEditHeader';
import Transactions from 'components/Payments/Transactions';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';
import ClientTransactionsEmpty from './ClientTransactionsEmpty';

interface ClientTransactionsProps {
    client: Client;
    onBook: () => void;
    onClose: () => void;
    onSelect: (key: string) => void;
    showTransactions?: boolean;
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            backgroundColor: '#fff',
            minHeight: '100%'
        },
        header: {
            padding: '24px 16px 0px'
        }
    })
);

const ClientTransactions: React.FC<ClientTransactionsProps> = ({
    client,
    onBook,
    onClose,
    onSelect,
    showTransactions
}) => {
    const classes = useStyles();
    const isMobile = useIsMobile();

    return (
        <Box className={classes.root}>
            {isMobile && (
                <Box className={classes.header}>
                    <ClientEditHeader
                        client={client}
                        onSelect={onSelect}
                        onBook={onBook}
                        onClose={onClose}
                        showTransactions={showTransactions}
                    />
                </Box>
            )}

            <Transactions
                clientId={client.id}
                emptyState={<ClientTransactionsEmpty />}
            />
        </Box>
    );
};

export default ClientTransactions;
